import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {Provider} from '../model/Provider';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {User} from '../model/User';

@Injectable()
export class DefaultApi {



  constructor(public http: HttpClient){

  }

  getProviders(){
     return this.http.get<any>('/auth/providers')
       .pipe(map((value: any[]) => value.map(provider => {
         return new Provider({
           providerName: provider.providerName,
           providerLink: provider.providerLink
         });
       })));

  }

  login(credentials: any/*, response: string*/) {
    const data = {
      userEmail: credentials.username.trim(),
      textMessage: credentials.textMessage.trim(),
      captcha: credentials.captcha
    };
    return this.http.post<any>('/auth/login', data, {headers: this.getHeaders()});
  }

  socialLogin(uri) {
    const url = `/auth/socialLogin/facebook/`;
    const headers = new HttpHeaders({
      Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9'
    });
    return this.http.get(url);
  }
  private getHeaders(){
    return  new HttpHeaders ({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });
  }

  getUserInfo(): Observable<any> {
    return this.http.get<any>('/admin/getUserInfo', {headers: this.getHeaders()});
  }

  acceptCookie(): Observable<any> {
    const url = `/auth/acceptCookie`;
    return this.http.post(url, null);
  }

  initSession(): Observable<any> {
    const url = `/auth/initSession`;
    return this.http.get(url);
  }

  getManagers(userId): Observable<any> {
    const url = `/admin/getUserManagers`;
    return this.http.get(url)
      .pipe(map((managers: any[]) => managers.map(manager => {
        return new User(({
          userId: manager.userId,
          userName: manager.userName,
          userLastName: manager.userLastName,
          userEmail: manager.userEmail,
          userPhoneNumber: manager.userPhoneNumber,
          hasPhoto: manager.hasPhoto
        }));
      })));
  }



  getRecoverPasswordLink(data) {
    const url = `/auth/sendRecoverPasswordLink`;
    return this.http.post(url, data);
  }

  recoverPassword(credentials): Observable<any> {
    const url = `/auth/recoverPassword`;
    return this.http.post(url, credentials);
  }
}
